import {
  Box,
  Typography,
  Button,
  Modal,
  Card,
} from "@mui/material";

import { colors } from "../../values/colors";
import { useGetAllRolesQuery } from "../../services/auctionAPI";
import PlayerAuctionCard from "../PlayerAuctionCard";

const NextPlayerModal = ({
  open,
  onClose,
  player,
  onConfirm,
  isJitoTournament,
  playerNumber,
}) => {
  const { data: rolesData } = useGetAllRolesQuery();
  const roles = rolesData?.data || [];

  const roleName = roles?.find(
    (r) => r?._id === player?.playerId?.roleId
  )?.name;



  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: 1100,
          p: 3,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0,0,0,0.15)",
          textAlign: "left",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: 600,
            mb: 3,
            fontSize: "1.6rem",
          }}
        >
          Next player up for auction
        </Typography>

        <PlayerAuctionCard
          player={player}
          playerNumber={playerNumber}
          roleName={roleName}
          isJitoTournament={isJitoTournament}
          showVisibilityIcon={false}
        />

        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              background: colors.linearGradent,
              color: "#fff",
              textTransform: "none",
              borderRadius: "999px",
              width: "150px",
              fontSize: "1.5rem",
            }}
          >
            Continue
          </Button>
        </Box>
      </Card>
    </Modal>
  );
};

export default NextPlayerModal;
